import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  billDueDate: "",
  currentDueBalance: "",
  paidAmount: "",
  ziplyPlanName: "",
  error: false,
  APIStatus: 0,
  billingAddress: "",
  paymentsMigrationToNDS: false,
  VOIPEnabled: false,
  VOIPServicePeriodId: "",
  VOIPDetails: [],
  month: "",
  VOIPTotalAmount: "",
  VOIPTotalEvents: "",
  isNewCustomer: false,
  isSMB: false,
  paymentConfirmationMessage: "",
  VOIPEnable: false,
  serviceAddress: "",
  autopayAmount: "",
  paperlessAmount: "",
  showAutopay: false,
  NDSInprogressAccount: false,
  paymentThreshold: "",
  totalMonthlyCharge: "",
  autopaySurchargeDetails: {
    surchargeEligible: false,
    homeScreenMessage: "",
    paymentScreenMessage: "",
    autopayCancelMessage: "",
    autopayDeactivateMessage: "",
  },
  isSuspended: false,
  usi: "",
  showAutopayDiscountMessage: true,
};

const customerPlanDetailsSlice = createSlice({
  name: "customerPlanDetails",
  initialState,
  reducers: {
    customerPlanDetails: (state, action) => {
      state.billDueDate = action.payload.billDueDate;
      state.currentDueBalance = action.payload.currentDueBalance;
      state.ziplyPlanName = action.payload.ziplyPlanName;
      state.error = action.payload.error;
      state.APIStatus = action.payload.APIStatus;
      state.billingAddress = action.payload.billingAddress;
      state.paymentsMigrationToNDS = action.payload.paymentsMigrationToNDS;
      state.VOIPEnabled = action.payload.VOIPEnabled;
      state.isNewCustomer = action.payload.isNewCustomer;
      state.isSMB = action.payload.isSMB;
      state.serviceAddress = action.payload.serviceAddress;
      state.autopayAmount = action.payload.autopayAmount;
      state.paperlessAmount = action.payload.paperlessAmount;
      state.NDSInprogressAccount = action.payload.NDSInprogressAccount;
      state.isSuspended = action.payload.isSuspended;
      state.usi = action.payload.usi;
      state.showAutopayDiscountMessage = action.payload.showAutopayDiscountMessage;
    },
    setExcessPaymentValues: (state, action) => {
      state.totalMonthlyCharge = action.payload.totalMonthlyCharge;
      state.paymentThreshold = action.payload.paymentThreshold;
    },
    setpaidAmount: (state, action) => {
      state.paidAmount = action.payload;
    },
    setVOIPServicePeriodId: (state, action) => {
      state.VOIPServicePeriodId = action.payload;
    },
    setVOIPDetails: (state, action) => {
      state.VOIPDetails = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setVoipTotalAmount: (state, action) => {
      state.VOIPTotalAmount = action.payload;
    },
    setVOIPTotalEvents: (state, action) => {
      state.VOIPTotalEvents = action.payload;
    },
    setPaymentConfirmationMessage: (state, action) => {
      state.paymentConfirmationMessage = action.payload;
    },
    setVOIPEnable: (state, action) => {
      state.VOIPEnable = action.payload;
    },
    setShowAutopay: (state, action) => {
      state.showAutopay = action.payload;
    },
    setAutopaySurchargeDetails: (state, action) => {
      state.autopaySurchargeDetails = action.payload;
    },
  },
});

export const {
  customerPlanDetails,
  setVOIPServicePeriodId,
  setVOIPDetails,
  setMonth,
  setVoipTotalAmount,
  setVOIPTotalEvents,
  setPaymentConfirmationMessage,
  setVOIPEnable,
  setShowAutopay,
  setExcessPaymentValues,
  setAutopaySurchargeDetails,
  setpaidAmount,
} = customerPlanDetailsSlice.actions;
export const customerPlanDetailsReducer = customerPlanDetailsSlice.reducer;
